import { put } from 'redux-saga/effects';

import { InsighttNotification } from '../../helpers/insightt-notification';
import TodoListActions from '../actions/todolist.actions';

export function* getTodoChecklistRequest(api) {
  const response = yield api.getTodoChecklist();
  if (response && response.ok) {
    yield put(TodoListActions.getTodoChecklistSuccess(response.data));
  } else {
    yield put(TodoListActions.getTodoChecklistFailure());
  }
}

export function* submitTodoChecklistRequest(api, action) {
  const { checklistId, payload } = action;
  const response = yield api.submitTodoChecklist(checklistId, payload);
  if (response && response.ok) {
    InsighttNotification('success', 'Checklist successfully updated', response);
    yield put(TodoListActions.submitTodoChecklistSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to submit checklist', response);
    yield put(TodoListActions.submitTodoChecklistFailure());
  }
}

export function* updateChecklistCommentRequest(api, action) {
  const { commentId, payload } = action;
  const response = yield api.updateChecklistComment(commentId, payload);
  if (response && response.ok) {
    InsighttNotification('success', 'Comment successfully updated', response);
    yield put(TodoListActions.updateChecklistCommentSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to update comment', response);
    yield put(TodoListActions.updateChecklistCommentFailure(commentId));
  }
}

export function* deleteChecklistCommentRequest(api, action) {
  const { commentId } = action;
  const response = yield api.deleteChecklistComment(commentId);
  if (response && response.ok) {
    InsighttNotification('success', 'Comment successfully deleted', response);
    yield put(TodoListActions.deleteChecklistCommentSuccess(commentId));
  } else {
    InsighttNotification('error', 'Unable to delete comment', response);
    yield put(TodoListActions.deleteChecklistCommentFailure(commentId));
  }
}

export function* getUsersCustomCommissionsRequest(api) {
  const response = yield api.getCustomCommissions();
  if (response && response.ok) {
    yield put(TodoListActions.getUsersCustomCommissionsSuccess(response.data));
  } else {
    yield put(TodoListActions.getUsersCustomCommissionsFailure());
  }
}

export function* approveCustomCommissionRequest(api, action) {
  const { commissionId } = action;
  const response = yield api.approveCustomCommission(commissionId);
  if (response && response.ok) {
    InsighttNotification('success', 'The custom commission was approved successfully');
    yield put(TodoListActions.approveCustomCommissionSuccess(commissionId));
    yield put(TodoListActions.getUsersCustomCommissionsRequest());
  } else {
    InsighttNotification('error', 'Unable to approve custom commission', response);
    yield put(TodoListActions.approveCustomCommissionFailure(commissionId));
  }
}

export function* declineCustomCommissionRequest(api, action) {
  const { commissionId } = action;
  const response = yield api.declineCustomCommission(commissionId);
  if (response && response.ok) {
    InsighttNotification('success', 'The custom commission was declined successfully');
    yield put(TodoListActions.declineCustomCommissionSuccess(commissionId));
    yield put(TodoListActions.getUsersCustomCommissionsRequest());
  } else {
    InsighttNotification('error', 'Unable to decline custom commission', response);
    yield put(TodoListActions.declineCustomCommissionFailure(commissionId));
  }
}
